import { render, staticRenderFns } from "./TableHeadDataInstallation.vue?vue&type=template&id=ec413db4"
import script from "./TableHeadDataInstallation.vue?vue&type=script&lang=ts"
export * from "./TableHeadDataInstallation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports